import type { Expert, ExpertDetail, ExpertPage, operations } from '..';
import { api } from '../api';
import { invalidator, provider, tags } from '../tags';

export type FilterArgs = Record<keyof operations['listExperts']['parameters']['query'], Array<string>>;

function encodeUrlWithParams(url: string, params: Record<string, Array<string>>): string {
  /* Hack to make RTK use Array URL params of style &foo=1&foo=2&foo=3*/
  if (!params) {
    return url;
  }

  let runningParamString = '';
  for (const [key, values] of Object.entries(params)) {
    let keyParamString = '';
    for (const value of values) {
      keyParamString += `&${key}=${value}`;
    }
    runningParamString += keyParamString;
  }
  const newUrl = `${url}${runningParamString}`;
  return newUrl;
}

export const expertApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    expert: builder.query<Expert, string>({
      query: (id: string) => `api/expert-network/expert/${id}/`,
      providesTags: provider<Expert>(tags.expert, 'expert_id'),
    }),

    expertDetail: builder.query<ExpertDetail, void>({
      query: () => 'api/expertdetail/me/',
      providesTags: provider<ExpertDetail>(tags.expert, 'expert_id'),
    }),

    experts: builder.query<ExpertPage, FilterArgs>({
      query: (filters) => ({
        url: encodeUrlWithParams('api/expert-network/expert/?', filters),
      }),
      providesTags: (page) => {
        return page ? page.results.map((expert) => ({ type: tags.expert, id: expert.expert_id })) : [];
      },
    }),

    updateExpertDetail: builder.mutation<ExpertDetail, Partial<ExpertDetail>>({
      query: (data) => ({
        url: 'api/expertdetail/me/',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: invalidator(tags.expert, 'expert_id'),
    }),
  }),
});
